"use client";

import { lazy, Suspense, useState } from "react";
import { ErrorBoundary } from "@/components/error/error-boundary";
import { DialogDismissalLayer } from "@/components/ui/dialog-dismissal-layer";
import { LoadFailureDialog } from "@/components/ui/load-failure-dialog";
import { useSearchContext } from "./search-context";

function SearchLoading() {
  const { isOpen, closeSearch } = useSearchContext();
  return (
    <DialogDismissalLayer open={isOpen} onOpenChange={closeSearch}>
      <span role="status" className="sr-only">
        Loading search…
      </span>
    </DialogDismissalLayer>
  );
}

const SearchDialog = lazy(() =>
  import("./search-dialog").then((module) => ({ default: module.SearchDialog })),
);

function SearchLoadFailure() {
  const { isOpen, closeSearch } = useSearchContext();
  return (
    <LoadFailureDialog
      title="Search could not load"
      open={isOpen}
      onOpenChange={closeSearch}
    />
  );
}

export function DeferredSearchDialog() {
  const { isOpen } = useSearchContext();
  const [hasOpened, setHasOpened] = useState(isOpen);
  if (isOpen && !hasOpened) setHasOpened(true);
  if (!hasOpened) return null;

  return (
    <ErrorBoundary label="search-dialog" fallback={<SearchLoadFailure />}>
      <Suspense fallback={<SearchLoading />}>
        <SearchDialog />
      </Suspense>
    </ErrorBoundary>
  );
}
